export default __webpack_public_path__ + "static/media/GalleryFirstTOIFullSize.70ce8fa6.jpg";